import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import gsap from "gsap";

export class MapOxxoTopicTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Estantes_refris = gltf.scene.getObjectByName("Estantes_refris", true);

			this.Pan_dulce = gltf.scene.getObjectByName("Pan_dulce", true);
			this.Puerta = gltf.scene.getObjectByName("Puerta", true);
			this.Puerta_1 = gltf.scene.getObjectByName("Puerta_1", true);
			this.Microondas = gltf.scene.getObjectByName("Microondas", true);

			this.Bolsa_1 = gltf.scene.getObjectByName("Bolsa_1", true);
			this.Yoghurt_20 = gltf.scene.getObjectByName("Yoghurt_20", true);
			this.Yoghurt_9 = gltf.scene.getObjectByName("Yoghurt_9", true);

			this.Refirs_Delixia = gltf.scene.getObjectByName("Refirs_Delixia", true);

			const newMaterialBolsa_1 = this.Bolsa_1.material.clone();
			newMaterialBolsa_1.transparent = true
			this.Bolsa_1.material = newMaterialBolsa_1

			const newMaterialYoghurt_20 = this.Yoghurt_20.material.clone();
			newMaterialYoghurt_20.transparent = true
			this.Yoghurt_20.material = newMaterialYoghurt_20

			const newMaterialYoghurt_9 = this.Yoghurt_9.material.clone();
			newMaterialYoghurt_9.transparent = true
			this.Yoghurt_9.material = newMaterialYoghurt_9

			// iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null

		}
		if (this.multiAnimationEmissive) {
			this.multiAnimationEmissive.kill()
			this.multiAnimationEmissive = null
		}
		this.Bolsa_1.material.emissiveIntensity = 0
		this.Yoghurt_20.material.emissiveIntensity = 0
		this.Yoghurt_9.material.emissiveIntensity = 0
	}

	onAnimateEmissiveIntensity(object) {
		this.clearAnimation()

		if (!object) {
			return
		}

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimateEmissiveMultiIntensity(object = []) {
		this.clearAnimation()

		if (object.length === 0) {
			return
		}

		const materialObject = object.map((obj) => {
			return obj.material
		})

		this.multiAnimationEmissive = gsap.to(materialObject, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimationOpacity(object, callback = () => { }) {
		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.transparent = true
		gsap.to(object.material, {
			opacity: 0,
			duration: 2,
			onComplete: () => {
				callback()
			},
		});
	}

	renderAnimations() { }
}
